"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTags = exports.tagsFlat = exports.tagDisplayOrder = exports.genresFlat = exports.categories = exports.tags = exports.genres = void 0;
exports.genres = [
    [
        {
            id: "1",
            tag_name: "Acoustic",
            urlsafe_name: "acoustic",
            tag_order: "2",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "10",
            tag_name: "Ambient",
            urlsafe_name: "ambient",
            tag_order: "1",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "142",
                    tag_name: "Soundscape",
                    urlsafe_name: "drone",
                    tag_order: null,
                    is_genre: "1",
                    parent_id: "10",
                    searchparam: "reductive"
                }
            ]
        },
        {
            id: "55",
            tag_name: "Blues",
            urlsafe_name: "blues",
            tag_order: "5",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        }
    ],
    [
        {
            id: "63",
            tag_name: "Country",
            urlsafe_name: "country",
            tag_order: "6",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "49",
            tag_name: "Drums",
            urlsafe_name: "drums",
            tag_order: "8",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "6",
            tag_name: "Electronic",
            urlsafe_name: "electronic",
            tag_order: "9",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "123",
                    tag_name: "Dance/House",
                    urlsafe_name: "dance_house",
                    tag_order: "10",
                    is_genre: "1",
                    parent_id: "6",
                    searchparam: "additive"
                },
                {
                    id: "124",
                    tag_name: "Downtempo",
                    urlsafe_name: "downtempo",
                    tag_order: "11",
                    is_genre: "1",
                    parent_id: "6",
                    searchparam: "additive"
                }
            ]
        }
    ],
    [
        {
            id: "66",
            tag_name: "Folk",
            urlsafe_name: "folk",
            tag_order: "4",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "41",
            tag_name: "Funk",
            urlsafe_name: "funk",
            tag_order: "14",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "8",
            tag_name: "Hip Hop",
            urlsafe_name: "hip_hop",
            tag_order: "15",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        }
    ],
    [
        {
            id: "45",
            tag_name: "Holiday",
            urlsafe_name: "holiday",
            tag_order: "16",
            is_genre: "1",
            parent_id: null,
            searchparam: "reductive"
        },
        {
            id: "11",
            tag_name: "International",
            urlsafe_name: "international",
            tag_order: "18",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "72",
                    tag_name: "African",
                    urlsafe_name: "african",
                    tag_order: "19",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "73",
                    tag_name: "Asian",
                    urlsafe_name: "asian",
                    tag_order: "20",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "85",
                    tag_name: "Bossa Nova",
                    urlsafe_name: "bossa_nova",
                    tag_order: "34",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "74",
                    tag_name: "East European",
                    urlsafe_name: "east_european",
                    tag_order: "21",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "75",
                    tag_name: "French",
                    urlsafe_name: "french",
                    tag_order: "22",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "76",
                    tag_name: "German",
                    urlsafe_name: "german",
                    tag_order: "23",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "77",
                    tag_name: "Tropical",
                    urlsafe_name: "hawaiian",
                    tag_order: "24",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "83",
                    tag_name: "India",
                    urlsafe_name: "india",
                    tag_order: "25",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "78",
                    tag_name: "Irish",
                    urlsafe_name: "irish",
                    tag_order: "26",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "79",
                    tag_name: "Italian",
                    urlsafe_name: "italian",
                    tag_order: "27",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "80",
                    tag_name: "Latin",
                    urlsafe_name: "latin",
                    tag_order: "28",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "81",
                    tag_name: "Middle Eastern",
                    urlsafe_name: "middle_eastern",
                    tag_order: "29",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "98",
                    tag_name: "Polka",
                    urlsafe_name: "polka",
                    tag_order: "30",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "82",
                    tag_name: "Reggae",
                    urlsafe_name: "reggae",
                    tag_order: "31",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                },
                {
                    id: "126",
                    tag_name: "Tango",
                    urlsafe_name: "tango",
                    tag_order: "32",
                    is_genre: "1",
                    parent_id: "11",
                    searchparam: "additive"
                }
            ]
        },
        {
            id: "12",
            tag_name: "Jazz",
            urlsafe_name: "jazz",
            tag_order: "33",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "86",
                    tag_name: "Jazz Ballad",
                    urlsafe_name: "jazz_ballad",
                    tag_order: "35",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "87",
                    tag_name: "Bebop",
                    urlsafe_name: "bebop",
                    tag_order: "36",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "88",
                    tag_name: "Big Band/Swing",
                    urlsafe_name: "big_band_swing",
                    tag_order: "37",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "89",
                    tag_name: "Exotica",
                    urlsafe_name: "exotica",
                    tag_order: "38",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "90",
                    tag_name: "Latin Jazz",
                    urlsafe_name: "latin_jazz",
                    tag_order: "39",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "91",
                    tag_name: "Old Time Jazz",
                    urlsafe_name: "old_time_jazz",
                    tag_order: "40",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "127",
                    tag_name: "New Orleans",
                    urlsafe_name: "new_orleans",
                    tag_order: "41",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                },
                {
                    id: "92",
                    tag_name: "Spy Jazz",
                    urlsafe_name: "spy_jazz",
                    tag_order: "42",
                    is_genre: "1",
                    parent_id: "12",
                    searchparam: "additive"
                }
            ]
        }
    ],
    [
        {
            id: "93",
            tag_name: "Lounge",
            urlsafe_name: "lounge",
            tag_order: "43",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "100",
                    tag_name: "Elevator",
                    urlsafe_name: "elevator",
                    tag_order: "44",
                    is_genre: "1",
                    parent_id: "93",
                    searchparam: "additive"
                }
            ]
        },
        {
            id: "48",
            tag_name: "Mnemonic",
            urlsafe_name: "mnemonic",
            tag_order: null,
            is_genre: "1",
            parent_id: null,
            searchparam: "reductive"
        },
        {
            id: "95",
            tag_name: "New Age",
            urlsafe_name: "new_age",
            tag_order: "44",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        }
    ],
    [
        {
            id: "7",
            tag_name: "Orchestral",
            urlsafe_name: "orchestral",
            tag_order: "45",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "56",
                    tag_name: "Classical",
                    urlsafe_name: "classical",
                    tag_order: "49",
                    is_genre: "1",
                    parent_id: "7",
                    searchparam: "additive"
                },
                {
                    id: "59",
                    tag_name: "Marching Band",
                    urlsafe_name: "marching_band",
                    tag_order: "50",
                    is_genre: "1",
                    parent_id: "7",
                    searchparam: "additive"
                },
                {
                    id: "60",
                    tag_name: "Opera",
                    urlsafe_name: "opera",
                    tag_order: "51",
                    is_genre: "1",
                    parent_id: "7",
                    searchparam: "additive"
                }
            ]
        },
        {
            id: "47",
            tag_name: "Pop",
            urlsafe_name: "pop",
            tag_order: "53",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "128",
                    tag_name: "Acoustic Pop",
                    urlsafe_name: "acoustic_pop",
                    tag_order: "54",
                    is_genre: "1",
                    parent_id: "47",
                    searchparam: "additive"
                },
                {
                    id: "64",
                    tag_name: "Disco",
                    urlsafe_name: "disco",
                    tag_order: "7",
                    is_genre: "1",
                    parent_id: "47",
                    searchparam: "additive"
                },
                {
                    id: "121",
                    tag_name: "Electronic Pop",
                    urlsafe_name: "electronic_pop",
                    tag_order: "55",
                    is_genre: "1",
                    parent_id: "47",
                    searchparam: "additive"
                },
                {
                    id: "129",
                    tag_name: "Happy Pop",
                    urlsafe_name: "happy_pop",
                    tag_order: "56",
                    is_genre: "1",
                    parent_id: "47",
                    searchparam: "additive"
                },
                {
                    id: "130",
                    tag_name: "Indie Pop",
                    urlsafe_name: "indie_pop",
                    tag_order: "57",
                    is_genre: "1",
                    parent_id: "47",
                    searchparam: "additive"
                }
            ]
        },
        {
            id: "99",
            tag_name: "R&B",
            urlsafe_name: "r_and_b",
            tag_order: "58",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "68",
                    tag_name: "Gospel",
                    urlsafe_name: "gospel",
                    tag_order: "59",
                    is_genre: "1",
                    parent_id: "99",
                    searchparam: "additive"
                },
                {
                    id: "109",
                    tag_name: "Soul",
                    urlsafe_name: "soul",
                    tag_order: "60",
                    is_genre: "1",
                    parent_id: "99",
                    searchparam: "additive"
                }
            ]
        }
    ],
    [
        {
            id: "3",
            tag_name: "Rock",
            urlsafe_name: "rock",
            tag_order: "61",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "101",
                    tag_name: "90's Rock",
                    urlsafe_name: "alternative",
                    tag_order: "62",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "131",
                    tag_name: "Folk Rock",
                    urlsafe_name: "folk_rock",
                    tag_order: "63",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "132",
                    tag_name: "Indie Rock",
                    urlsafe_name: "indie_rock",
                    tag_order: "64",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "133",
                    tag_name: "Light Rock",
                    urlsafe_name: "light_rock",
                    tag_order: "65",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "102",
                    tag_name: "Southern Rock",
                    urlsafe_name: "southern_rock",
                    tag_order: "66",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "103",
                    tag_name: "Metal",
                    urlsafe_name: "metal",
                    tag_order: "67",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "104",
                    tag_name: "Psychedelic",
                    urlsafe_name: "psychedelic",
                    tag_order: "68",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "105",
                    tag_name: "Punk Rock",
                    urlsafe_name: "punk_rock",
                    tag_order: "69",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "134",
                    tag_name: "Pop Rock",
                    urlsafe_name: "pop_rock",
                    tag_order: "70",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "106",
                    tag_name: "Prog Rock",
                    urlsafe_name: "prog_rock",
                    tag_order: "71",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "107",
                    tag_name: "Surf Rock",
                    urlsafe_name: "surf_rock",
                    tag_order: "72",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                },
                {
                    id: "108",
                    tag_name: "Ska",
                    urlsafe_name: "ska",
                    tag_order: "73",
                    is_genre: "1",
                    parent_id: "3",
                    searchparam: "additive"
                }
            ]
        },
        {
            id: "61",
            tag_name: "Solo Piano",
            urlsafe_name: "solo_piano",
            tag_order: "52",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive"
        },
        {
            id: "150",
            tag_name: "Decades",
            urlsafe_name: "decades",
            tag_order: "143",
            is_genre: "1",
            parent_id: null,
            searchparam: "additive",
            children: [
                {
                    id: "110",
                    tag_name: "Fifties",
                    urlsafe_name: "era_1950s",
                    tag_order: "144",
                    is_genre: "1",
                    parent_id: "150",
                    searchparam: "additive"
                },
                {
                    id: "111",
                    tag_name: "Sixties",
                    urlsafe_name: "era_1960s",
                    tag_order: "145",
                    is_genre: "1",
                    parent_id: "150",
                    searchparam: "additive"
                },
                {
                    id: "112",
                    tag_name: "Seventies",
                    urlsafe_name: "era_1970s",
                    tag_order: "146",
                    is_genre: "1",
                    parent_id: "150",
                    searchparam: "additive"
                },
                {
                    id: "113",
                    tag_name: "Eighties",
                    urlsafe_name: "era_1980s",
                    tag_order: "147",
                    is_genre: "1",
                    parent_id: "150",
                    searchparam: "additive"
                }
            ]
        }
    ]
];
exports.tags = [
    {
        id: "37",
        tag_name: "Action",
        urlsafe_name: "action",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "18",
        tag_name: "Anthemic",
        urlsafe_name: "anthemic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "139",
        tag_name: "Bold",
        urlsafe_name: "tough",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "52",
        tag_name: "Builds",
        urlsafe_name: "builds",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "161",
        tag_name: "Calm",
        urlsafe_name: "calm",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "24",
        tag_name: "Cinematic",
        urlsafe_name: "cinematic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "135",
        tag_name: "Comedic",
        urlsafe_name: "comedy",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "160",
        tag_name: "Confident",
        urlsafe_name: "confident",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "26",
        tag_name: "Dark",
        urlsafe_name: "dark",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "30",
        tag_name: "Delicate",
        urlsafe_name: "delicate",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "20",
        tag_name: "Dreamy",
        urlsafe_name: "dreamy",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "115",
        tag_name: "Driving",
        urlsafe_name: "driving",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "25",
        tag_name: "Energetic",
        urlsafe_name: "energy",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "116",
        tag_name: "Epic",
        urlsafe_name: "epic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "162",
        tag_name: "Fun",
        urlsafe_name: "fun",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "27",
        tag_name: "Gritty",
        urlsafe_name: "gritty",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "19",
        tag_name: "Happy",
        urlsafe_name: "happy",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "51",
        tag_name: "Heroic",
        urlsafe_name: "heroic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "13",
        tag_name: "Hopeful",
        urlsafe_name: "hopeful",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "36",
        tag_name: "Indie",
        urlsafe_name: "indie",
        tag_order: "17",
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "117",
        tag_name: "Innocent",
        urlsafe_name: "innocent",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "118",
        tag_name: "Inspirational",
        urlsafe_name: "inspirational",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "15",
        tag_name: "Ironic",
        urlsafe_name: "ironic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "2",
        tag_name: "Light",
        urlsafe_name: "lighter_side",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "163",
        tag_name: "Lush",
        urlsafe_name: "lush",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "43",
        tag_name: "Magical",
        urlsafe_name: "magical",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "31",
        tag_name: "Mellow",
        urlsafe_name: "mellow",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "28",
        tag_name: "Minimal",
        urlsafe_name: "minimal",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "39",
        tag_name: "Mysterious",
        urlsafe_name: "mysterious",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "29",
        tag_name: "Organic",
        urlsafe_name: "organic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "23",
        tag_name: "Playful",
        urlsafe_name: "playful",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "138",
        tag_name: "Positive",
        urlsafe_name: "positive",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "119",
        tag_name: "Pulsating",
        urlsafe_name: "pulsating",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "5",
        tag_name: "Quirky",
        urlsafe_name: "quirky",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "9",
        tag_name: "Retro",
        urlsafe_name: "retro",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "38",
        tag_name: "Romantic",
        urlsafe_name: "romantic",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "120",
        tag_name: "Sad",
        urlsafe_name: "sad",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "164",
        tag_name: "Seductive",
        urlsafe_name: "seductive",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "17",
        tag_name: "Sentimental",
        urlsafe_name: "sentimental",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "136",
        tag_name: "Mischievous",
        urlsafe_name: "sneaky",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "137",
        tag_name: "Sophisticated",
        urlsafe_name: "sophisticated",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    // {
    //   id: "50",
    //   tag_name: "Sports",
    //   urlsafe_name: "sports",
    //   tag_order: null,
    //   is_genre: "0",
    //   parent_id: null,
    //   searchparam: "reductive"
    // },
    {
        id: "21",
        tag_name: "Tension",
        urlsafe_name: "tension",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "4",
        tag_name: "Thoughtful",
        urlsafe_name: "thoughtful",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "22",
        tag_name: "Twang",
        urlsafe_name: "twang",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "166",
        tag_name: "Upbeat",
        urlsafe_name: "upbeat",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "46",
        tag_name: "Vocal",
        urlsafe_name: "vocal",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "14",
        tag_name: "Warm",
        urlsafe_name: "warm",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    },
    {
        id: "165",
        tag_name: "Whimsical",
        urlsafe_name: "whimsical",
        tag_order: null,
        is_genre: "0",
        parent_id: null,
        searchparam: "reductive"
    }
];
exports.categories = [
    {
        id: "1",
        category_name: "Acoustic",
        urlsafe_name: "acoustic",
        cover: "Acoustic.jpg"
    },
    {
        id: "2",
        category_name: "Action",
        urlsafe_name: "action",
        cover: "Action.jpg"
    },
    {
        id: "3",
        category_name: "Action Rhythm",
        urlsafe_name: "action-rhythm",
        cover: "Action-Rhythm.jpg"
    },
    {
        id: "4",
        category_name: "Ambient",
        urlsafe_name: "ambient",
        cover: "Ambient.jpg"
    },
    {
        id: "5",
        category_name: "Anthemic",
        urlsafe_name: "anthemic",
        cover: "Anthemic.jpg"
    },
    {
        id: "6",
        category_name: "Lounge",
        urlsafe_name: "bachelor-pad",
        cover: "Bachelor-Pad.jpg"
    },
    {
        id: "7",
        category_name: "Contemplative",
        urlsafe_name: "contemplative",
        cover: "Contemplative.jpg"
    },
    {
        id: "8",
        category_name: "Downtempo",
        urlsafe_name: "downtempo",
        cover: "Downtempo.jpg"
    },
    {
        id: "9",
        category_name: "Electro-Lounge",
        urlsafe_name: "electro-lounge",
        cover: "Electro-Lounge.jpg"
    },
    {
        id: "10",
        category_name: "Electronic",
        urlsafe_name: "electronic",
        cover: "Electronic.jpg"
    },
    {
        id: "11",
        category_name: "Emotional",
        urlsafe_name: "emotional",
        cover: "Emotional.jpg"
    },
    {
        id: "12",
        category_name: "Happy Happy Fun Time",
        urlsafe_name: "happy-happy-fun-time",
        cover: "Happy-Happy-Fun-Time.jpg"
    },
    {
        id: "13",
        category_name: "Hopeful",
        urlsafe_name: "hopeful",
        cover: "Hopeful.jpg"
    },
    {
        id: "14",
        category_name: "International",
        urlsafe_name: "international",
        cover: "International.jpg"
    },
    {
        id: "15",
        category_name: "Ironic",
        urlsafe_name: "ironic",
        cover: "Ironic.jpg"
    },
    {
        id: "16",
        category_name: "Jazz",
        urlsafe_name: "jazz",
        cover: "Jazz.jpg"
    },
    {
        id: "17",
        category_name: "Lighter Side",
        urlsafe_name: "lighter-side",
        cover: "Lighter-Side.jpg"
    },
    {
        id: "18",
        category_name: "Orchestral",
        urlsafe_name: "orchestral",
        cover: "Orchestral.jpg"
    },
    {
        id: "19",
        category_name: "Organic",
        urlsafe_name: "organic",
        cover: "Organic.jpg"
    },
    {
        id: "20",
        category_name: "Quirky",
        urlsafe_name: "quirky",
        cover: "Quirky.jpg"
    },
    {
        id: "22",
        category_name: "Retro Classics",
        urlsafe_name: "retro-classics",
        cover: "Retro-Classics.jpg"
    },
    {
        id: "23",
        category_name: "Rock",
        urlsafe_name: "rock",
        cover: "Rock.jpg"
    },
    {
        id: "24",
        category_name: "Uptempo",
        urlsafe_name: "uptempo",
        cover: "Uptempo.jpg"
    },
    {
        id: "25",
        category_name: "Hip Hop R&B",
        urlsafe_name: "hiphoprb",
        cover: "Hip-Hop-RB.jpg"
    },
    {
        id: "29",
        category_name: "Mnemonic",
        urlsafe_name: "mnemonic",
        cover: "Mnemonic.jpg"
    },
    {
        id: "30",
        category_name: "Holiday",
        urlsafe_name: "holiday",
        cover: "Holiday.jpg"
    },
    {
        id: "31",
        category_name: "Drums",
        urlsafe_name: "drums",
        cover: "Drums.jpg"
    },
    {
        id: "32",
        category_name: "Rock 2",
        urlsafe_name: "rock-2",
        cover: "Rock.jpg"
    },
    {
        id: "33",
        category_name: "Rock 3",
        urlsafe_name: "rock-3",
        cover: "Rock.jpg"
    },
    {
        id: "34",
        category_name: "Lighter Side 2",
        urlsafe_name: "lighter-side-2",
        cover: "Lighter-Side.jpg"
    },
    {
        id: "35",
        category_name: "Lighter Side 3",
        urlsafe_name: "lighter-side-3",
        cover: "Lighter-Side.jpg"
    }
];
const genreOrder = [
    "ambient",
    "acoustic",
    "folk",
    "blues",
    "country",
    "disco",
    "drums",
    "electronic",
    "dance_house",
    "downtempo",
    "aggressive",
    "funk",
    "hip_hop",
    "international",
    "african",
    "asian",
    "east_european",
    "french",
    "german",
    "hawaiian",
    "india",
    "irish",
    "italian",
    "latin",
    "middle_eastern",
    "polka",
    "reggae",
    "tango",
    "jazz",
    "bossa_nova",
    "jazz_ballad",
    "bebop",
    "big_band_swing",
    "exotica",
    "latin_jazz",
    "old_time_jazz",
    "new_orleans",
    "spy_jazz",
    "lounge",
    "new_age",
    "orchestral",
    "classical",
    "marching_band",
    "opera",
    "solo_piano",
    "pop",
    "acoustic_pop",
    "electronic_pop",
    "happy_pop",
    "indie_pop",
    "r_and_b",
    "gospel",
    "soul",
    "rock",
    "alternative",
    "folk_rock",
    "indie_rock",
    "light_rock",
    "southern_rock",
    "metal",
    "psychedelic",
    "punk_rock",
    "pop_rock",
    "prog_rock",
    "surf_rock",
    "ska",
    "era_1950s",
    "era_1960s",
    "era_1970s",
    "era_1980s",
    "decades",
    "holiday",
    "mnemonic"
];
let genresFlatIntermediate = [];
for (let i = 0; i < exports.genres.length; i += 1) {
    const genresRow = exports.genres[i];
    for (let j = 0; j < genresRow.length; j += 1) {
        const genre = genresRow[j];
        genresFlatIntermediate.push(genre);
        if (genre.children != null && genre.children.length > 0) {
            for (let k = 0; k < genre.children.length; k += 1) {
                genresFlatIntermediate.push(genre.children[k]);
            }
        }
    }
}
/*eslint-disable */
genresFlatIntermediate = genresFlatIntermediate.sort((g1, g2) => {
    return (genreOrder.indexOf(g1.urlsafe_name) - genreOrder.indexOf(g2.urlsafe_name));
});
/* eslint-enable */
exports.genresFlat = genresFlatIntermediate;
exports.tagDisplayOrder = [
    "action", "anthemic", "tough", "builds", "calm", "cinematic",
    "comedy", "confident", "dark", "delicate", "dreamy", "driving",
    "energy", "epic", "fun", "gritty", "happy", "heroic",
    "hopeful", "indie", "innocent", "inspirational", "ironic", "lighter_side",
    "lush", "magical", "mellow", "minimal", "sneaky", "mysterious",
    "organic", "playful", "positive", "pulsating", "quirky", "retro",
    "romantic", "sad", "seductive", "sentimental", "sophisticated", "tension",
    "thoughtful", "twang", "upbeat", "vocal", "warm", "whimsical",
];
// Note: do not sort `tags` in place here. Consumers such as the UI tag grid
// rely on this display order, while `tags` itself must keep its file order.
exports.tagsFlat = [...exports.tags].sort((t1, t2) => {
    const i1 = exports.tagDisplayOrder.indexOf(t1.urlsafe_name);
    const i2 = exports.tagDisplayOrder.indexOf(t2.urlsafe_name);
    return (i1 === -1 ? 999 : i1) - (i2 === -1 ? 999 : i2);
});
exports.allTags = [].concat(exports.tagsFlat).concat(exports.genresFlat);
